import React from 'react';
/** lib **/
import classNames from 'classnames';
import { Equipment } from 'components/organisms';
/** styles, images **/
import { ReactComponent as Pad } from 'assets/images/pad.svg';
import s from '../../styles/molecules/our-future-slider-item.module.scss';

type Props = {
  className?: string;
  number?: string;
  title?: string;
  contents: string[];
  images?: string[];
  imagePosition?: 'left' | 'bothEnds' | 'bothEndsDiffSize';
  imageHeight?: string;
  showEquipment?: boolean;
};
export const OurFutureSliderItem: React.FC<Props> = ({
  className,
  number,
  title,
  contents,
  images,
  imagePosition,
  imageHeight,
  showEquipment,
}) => {
  const imagePositionMap = {
    left: s.left,
    bothEnds: s.bothEnds,
    bothEndsDiffSize: s.bothEndsDiffSize,
  };
  const imagePositionStyle = (imagePosition && imagePositionMap[imagePosition]) || '';

  // 4つ目の要素（Equipment表示）の場合は特別なレイアウト
  if (showEquipment) {
    return (
      <div className={classNames(className, s.OurFutureSliderItemWrapper, s.equipmentLayout)}>
        <div className={s.inner}>
          <div className={s.headerSection}>
            <div className={s.contentsNumber}>
              <span>POINT</span>
              <p>{number}</p>
            </div>
            <div className={s.titleArea}>
              <h4>{title}</h4>
              <ul>
                {contents.map((content, index) => (
                  <li key={index}>
                    <Pad className={s.icon} />
                    <h5>{content}</h5>
                  </li>
                ))}
              </ul>
            </div>
            {images && (
              <div className={classNames(s.imageWrapper, imagePositionStyle)}>
                {images.map((image, index) => (
                  <img
                    key={index}
                    src={require(`assets/images/${image}`)}
                    alt={title}
                    style={imageHeight ? { height: imageHeight, width: 'auto' } : undefined}
                  />
                ))}
              </div>
            )}
          </div>
          <div className={s.equipmentSection}>
            <Equipment />
          </div>
        </div>
      </div>
    );
  }

  // 通常のレイアウト
  return (
    <div className={classNames(className, s.OurFutureSliderItemWrapper)}>
      <div className={s.inner}>
        <div className={s.contentArea}>
          <div className={s.contentsNumber}>
            <span>POINT</span>
            <p>{number}</p>
          </div>
          <div className={s.textContent}>
            <h4>{title}</h4>
            <ul>
              {contents.map((content, index) => (
                <li key={index}>
                  <Pad className={s.icon} />
                  <h5>{content}</h5>
                </li>
              ))}
            </ul>
          </div>
        </div>
        {images && (
          <div className={classNames(s.imageWrapper, imagePositionStyle)}>
            {images.map((image, index) => (
              <img
                key={index}
                src={require(`assets/images/${image}`)}
                alt={title}
                style={imageHeight ? { height: imageHeight, width: 'auto' } : undefined}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
